<template>
	<div class="multiply-input">
		<div class="multiply-input__input">
			<InputText v-for="(input, index) in inputs" :key="index" v-model="input.value" :label="'Телефон *'" :errors="v$.inputs[index].value.$errors" :placeholder="'+'" :phone="true" />
			
			<div v-if="inputs.length > 1" class="multiply-input__btn">
				<label class="multiply-input__btn-label">Действие</label>
				<button class="btn btn--border btn--cancel" @click="removeInput">Удалить</button>
			</div>			
			<div v-if="inputs.length < 5" class="multiply-input__btn">
				<label class="multiply-input__btn-label">Действие</label>
				<button class="btn btn--border" @click="addInput">Добавить</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import useVuelidate from "@vuelidate/core";
import {required, helpers, minLength, maxLength} from '@vuelidate/validators'
const {withMessage} = helpers

export default {
	name: "InputMultiply",
	emits:['update:modelValue'],
	components: {InputText},
	props: {
		modelValue: {
			type: [Array, String],
		},
		phones: {
			type: Array,
			default: () => []
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	created() {
		if(this.phones.length) {
			this.inputs.pop()
			this.phones.forEach(element => {
				this.inputs.push({ value: element })
			});
		}
	},
	data() {
		return {
			inputs: [
				{ value: '' },
			],	
		}
	},
	methods: {
		addInput() {
			this.inputs.push({ value: '' })
		},
		removeInput() {
			this.inputs.pop()
		}
	},
	watch: {
		inputs: {
			handler() {
				this.$emit('update:modelValue', this.inputs.map(input => input.value))
			},
			deep: true
		}
	},
	validations() {
		return {
			inputs: this.inputs.map(input => ({
				...input,
				value: {
					required: withMessage("Заполните телефон", required),
					minLength: withMessage("В номере телефона должно быть минимум 8 цифр", minLength(9)),
					maxLength: withMessage("В номере телефона должно быть максимум 15 цифр", maxLength(16)),
				}
			}))
		}
	},
}
</script>


